import { useLayoutEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ChartAction } from "../../redux/states/chartState";
import { useWindowWidthAndHeight } from "../../shared/hooks/customHooks"
import './templateStyle.css';
import FilterModal from "../../modals/filterModal";
import { getFilterModal } from "../../redux/selectors/filterSelector";
import { FilterAction } from "../../redux/states/filterState";

export type Props = {
    filterContent: JSX.Element | JSX.Element[];
    graphContent?: JSX.Element | JSX.Element[];
    dataSource:string,
    pageName:string
    evmc?: boolean;
}

const PageTemplate: React.FC<Props> = ({
  filterContent,
  graphContent,
  dataSource,
  pageName,
  evmc
}) => {
  const dispatch = useDispatch();
  
  const [width] = useWindowWidthAndHeight()
  const ref = useRef<HTMLDivElement>(null);
  const filterModal = useSelector(getFilterModal);

  const closeModal = (): void => {
    dispatch(FilterAction.SetOpenFilterModal(false));
  }
  
  useLayoutEffect(() => {
    let newGraphWidth=0;
    if (ref.current) {
      newGraphWidth = ref.current.offsetWidth;
      dispatch(ChartAction.SetGraphWidth(newGraphWidth));
    }
  });

  return(<>
    <FilterModal handleClose={closeModal} open={filterModal.open}>
      {filterContent}
    </FilterModal>
    <div className="main-container">
      {
        width > 1150
        ? <div className="left-side">
            <div className="filter-box">
              <div className="filter-wrapper">
                <div className="filter-content">{filterContent}</div>
              </div>
              <div className="data-source"><p>{dataSource}</p></div>
            </div>
          </div>
        : undefined
      }
      <div ref={ref} className="graph-container">
        <div className="graph-bloc">
          {graphContent}
        </div>
      </div>
    </div>
  </>);
}

export default PageTemplate